import { Text, View } from "@react-pdf/renderer";

import { usePdfChromeScale } from "../pdf-page-chrome";

type SignedAtSlotProps = {
  signedAtDate?: string;
};

export default function SignedAtSlot({ signedAtDate }: SignedAtSlotProps) {
  // ENG-2277: lengths are a legacy page's px, scaled on a Form's page (see pdf-page-chrome).
  const { px } = usePdfChromeScale();
  return (
    <View
      style={{
        width: px(110),
        display: "flex",
        flexDirection: "row",
        gap: px(6),
        marginRight: px(7),
        marginBottom: px(7)
      }}
    >
      {Boolean(signedAtDate) && (
        <>
          <Text
            style={{
              fontSize: px(12),
              fontFamily: "LatoRegular",
              fontWeight: "bold"
            }}
          >
            Date
          </Text>
          <Text
            style={{
              fontSize: px(12),
              fontFamily: "LatoRegular"
            }}
          >
            {signedAtDate}
          </Text>
        </>
      )}
    </View>
  );
}
